// extracted by mini-css-extract-plugin
export default {"playing":"About_playing__ZgeP1","paused":"About_paused__sbgnG"};